import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
} from 'reactstrap';
import Input from '../../Input';
import FileUpload from '../../FileUpload';
import ImageDisplay from '../../ImageDisplay';

class Footer extends React.PureComponent {
  render() {
    const { validation, values } = this.props;

    return (
      <Row className="px-5 py-3 fade-in">
        <Col>
          <Input
            id="disclaimerText"
            type="textarea"
            pattern={validation.disclaimer_text}
            label="Disclaimer Text:"
            value={values.disclaimerText}
          />
          <FileUpload id="poweredByLogo" label="&apos;Powered By&apos; Logo" />
          <ImageDisplay id="poweredByLogo" />
        </Col>
        <Col />
      </Row>
    );
  }
}

const mapStateToProps = (store) => ({
  validation: store.theme.validation,
  values: store.sites.values,
});

export default connect(mapStateToProps)(Footer);
